module.exports = __webpack_public_path__ + "assets/img/al2.d74303a3.jpg";